import { MediaType, Product, ProductMedia } from '../interface/interface';

export default function renderMediaUrls(product: Product): Array<ProductMedia> {
  const mediaData: Array<ProductMedia> = [
    ...(product?.productImages?.map((p) => ({
      thumbnail: p.url,
      url: p.url,
      type: MediaType.IMAGE,
    })) || []),
    ...(product?.productVideos?.map((p) => ({
      thumbnail: p.thumbnail,
      url: p.url,
      type: MediaType.VIDEO,
    })) || []),
  ];

  if (!mediaData.length) {
    const defaultImage = product.image_url || '/default-image.png';
    mediaData.push({
      thumbnail: defaultImage,
      url: defaultImage,
      type: MediaType.IMAGE,
    });
  }

  return mediaData;
}
